module.exports = __webpack_public_path__ + "img/tick.b11c3e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tick.png
// module id = 7Awt
// module chunks = 1